import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { ThemeProvider } from "@mui/material";
import AgentDetails from "./AgentDetails";
import CssBaseline from "@mui/material/CssBaseline";
import theme from "../../assets/theme";
import "../../assets/base.css";

createRoot(document.getElementById("ahg-agent-details")).render(
	<StrictMode>
		<ThemeProvider theme={theme}>
			<CssBaseline />
			<AgentDetails />
		</ThemeProvider>
	</StrictMode>
);
